module.exports = __webpack_public_path__ + "img/full6-min.6f6eeaf3.png";